import { Box, styled } from "@mui/material";
import parse from "html-react-parser";
import _ from "lodash";

const HighlightTypography = styled(Box)(({ theme }) => ({
    '& b': {
        backgroundColor: theme.palette.grey[300],
        padding: '0 .4rem',
        borderRadius: '.3rem'
    }
}));

export default class SearchHiglight {
    static parse(text: string): string | JSX.Element {
        if (!text)
            return text;

        return (
            <HighlightTypography component="span">
                {parse(text.replace(/<highlight>/g, '<b>').replace(/<\/highlight>/g, '</b>'))}
            </HighlightTypography>
        )
    }
}